import { styled } from "@mui/material/styles";
import { CheckIcon, CopyIcon, IconButton, reducedMotion } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
const COPIED_MS = 1500;
const Actions = styled("div")({
    position: "absolute",
    top: "100%",
    left: "-0.4375rem",
    display: "flex",
    gap: "var(--j-sp-0-5)",
    color: "var(--j-ink-3)",
    opacity: 0,
    transition: "opacity var(--j-dur-fade) var(--j-ease)",
    ".message:hover &, &:focus-within, &[data-copied=true], &[data-pinned=true]": {
        opacity: 1
    },
    "@media (hover: none)": {
        opacity: 1
    },
    [reducedMotion]: {
        transition: "none"
    },
    "& > button": {
        color: "inherit",
        width: "1.5rem",
        height: "1.5rem"
    }
});
function messageText(message) {
    return message.parts.filter((p)=>p.type === "text").map((p)=>p.text).join("").trim();
}
export function MessageActions({ message, isPinned }) {
    const { t } = useTranslation();
    const [isCopied, setIsCopied] = React.useState(false);
    const text = messageText(message);
    if (!text) return null;
    const onCopy = async ()=>{
        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(true);
            window.setTimeout(()=>setIsCopied(false), COPIED_MS);
        } catch  {
        /* clipboard unavailable */ }
    };
    return /*#__PURE__*/ React.createElement(Actions, {
        "data-copied": isCopied,
        "data-pinned": isPinned
    }, /*#__PURE__*/ React.createElement(IconButton, {
        size: "sm",
        "aria-label": t(isCopied ? "chat.copied" : "chat.copy"),
        onClick: onCopy
    }, isCopied ? /*#__PURE__*/ React.createElement(CheckIcon, {
        size: 14,
        color: "var(--j-ok)"
    }) : /*#__PURE__*/ React.createElement(CopyIcon, {
        size: 14
    })));
}
